var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    {
      staticStyle: { "min-width": "978px !important" },
      attrs: { show: _vm.show }
    },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Detalle VOD" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [_c("span", [_vm._v("Detalle VOD")])]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "detail-vdo-view-detail", attrs: { align: "center" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm10: "", md8: "", lg7: "", xl6: "" } },
            [
              _c(
                "v-card",
                { staticClass: "rounded-card" },
                [
                  _c(
                    "v-container",
                    {
                      attrs: {
                        "grid-list-md": "",
                        "pt-30": "",
                        "px-40": "",
                        "pb-50": ""
                      }
                    },
                    [
                      _c(
                        "FormFieldsContainer",
                        { staticClass: "px-3" },
                        [
                          _c("div", { staticClass: "detail__title" }, [
                            _c(
                              "h2",
                              [
                                _vm._v(
                                  "\n                Detalle VOD Nº " +
                                    _vm._s(_vm.objectHeader.VOD) +
                                    "\n                "
                                ),
                                _c(
                                  "v-icon",
                                  {
                                    staticStyle: {
                                      "font-size": "32px",
                                      "margin-left": "3px"
                                    },
                                    attrs: { color: "#4c4949" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  videocam\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _c(
                            "v-flex",
                            {
                              staticClass: "detail__header",
                              attrs: {
                                xs10: "",
                                sm10: "",
                                md10: "",
                                layout: "",
                                "justify-start": "",
                                wrap: "",
                                "mb-5": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md12: "",
                                    layout: "",
                                    "align-center": ""
                                  }
                                },
                                [
                                  _c("h3", [_vm._v("Cámara:")]),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.objectHeader.CAMARA))
                                  ])
                                ]
                              ),
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md12: "",
                                    layout: "",
                                    "align-center": ""
                                  }
                                },
                                [
                                  _c("h3", [_vm._v("Channel:")]),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.objectHeader.CHL))
                                  ])
                                ]
                              ),
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md12: "",
                                    layout: "",
                                    "align-center": ""
                                  }
                                },
                                [
                                  _c("h3", [_vm._v("Estado:")]),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.objectHeader.ESTADO))
                                  ])
                                ]
                              ),
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md12: "",
                                    layout: "",
                                    "align-center": ""
                                  }
                                },
                                [
                                  _c("h3", [_vm._v("Mensaje:")]),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.objectHeader.MSG))
                                  ])
                                ]
                              ),
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md12: "",
                                    layout: "",
                                    wrap: "",
                                    "align-center": ""
                                  }
                                },
                                [
                                  _c("h3", [_vm._v("Fecha Último Intento:")]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.objectHeader.FECHA_ULT_REINTENTO
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md12: "",
                                    layout: "",
                                    wrap: "",
                                    "align-center": "",
                                    "mt-4": ""
                                  }
                                },
                                [
                                  _c("h3", [_vm._v("Fecha Inicio:")]),
                                  _c("span", { staticClass: "mr-1" }, [
                                    _vm._v(_vm._s(_vm.objectHeader.FECHA_INI))
                                  ]),
                                  _c("strong", [_vm._v(_vm._s("-"))]),
                                  _c("h3", { staticClass: "ml-1" }, [
                                    _vm._v("Fecha Fin:")
                                  ]),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.objectHeader.FECHA_FIN))
                                  ])
                                ]
                              ),
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md12: "",
                                    layout: "",
                                    wrap: "",
                                    "align-center": ""
                                  }
                                },
                                [
                                  _c("h3", [_vm._v("Fecha de Control:")]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.objectHeader.FECHA_CONTROL)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "detail__events",
                              attrs: { xs12: "", sm12: "", md12: "" }
                            },
                            [
                              _vm.listEvents.length > 0
                                ? _c("table", [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [_vm._v("Evento:")]),
                                        _c("th", [_vm._v("Fecha:")]),
                                        _c("th", [_vm._v("Mensaje:")])
                                      ])
                                    ]),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.listEvents, function(
                                        event,
                                        index
                                      ) {
                                        return _c("tr", { key: index }, [
                                          _c("td", [
                                            _vm._v(_vm._s(event.evento))
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(event.fecha))
                                          ]),
                                          _c("td", [_vm._v(_vm._s(event.msg))])
                                        ])
                                      }),
                                      0
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }